import { DragEvent, useState } from 'react'
import { noop } from '../noop'

export interface HoverEventHandlers {
  onMouseOver: () => void
  onMouseEnter: () => void
  onMouseLeave: () => void
  onDragEnd: (e: DragEvent) => void
}

export function useHover(
  disable = false
): [
  boolean,
  HoverEventHandlers,
  React.Dispatch<React.SetStateAction<boolean>>,
] {
  const [hovered, setHovered] = useState(false)

  if (disable) {
    return [
      false,
      {
        onMouseOver: noop,
        onMouseEnter: noop,
        onMouseLeave: noop,
        onDragEnd: noop,
      },
      noop,
    ]
  }

  const eventHandlers: HoverEventHandlers = {
    onMouseOver: () => setHovered(true),
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    onDragEnd: (e: DragEvent) => {
      if (e.target instanceof HTMLElement) {
        e.target.blur()
      }
    },
  }

  return [hovered, eventHandlers, setHovered]
}
